import {GlossaryTerm} from "../types/GlossaryTerm";

export const GLOSSARY_TERMS: GlossaryTerm[] = [
    {
        title: "Mediana",
        description:
            "Cena środkowa: połowa mieszkań jest tańsza, połowa droższa. Lepiej opisuje typowe mieszkanie, bo nie zawyżają jej pojedyncze, bardzo drogie nieruchomości."
    },
    {
        title: "Średnia",
        description: "Uśredniona wartość wszystkich mieszkań w danym okresie, obliczana jako suma ich cen dzielona przez ich liczbę."
    },
    {
        title: "r/r",
        description: "„rok do roku” – porównanie z tym samym miesiącem poprzedniego roku."
    },
    {
        title: "m/m",
        description: "„miesiąc do miesiąca” – porównanie z poprzednim miesiącem."
    },
    {
        title: "Rynek pierwotny",
        description: "Nowe mieszkania kupowane bezpośrednio od dewelopera."
    },
    {
        title: "RCN",
        description: "Rejestr Cen Nieruchomości – publiczne, bezpłatne źródło danych z wykazem cen transakcyjnych mieszkań."
    }
];
import {GlossaryTerm} from "../types/GlossaryTerm";

export const GLOSSARY_TERMS: GlossaryTerm[] = [
    {
        title: "Mediana",
        description:
            "Cena środkowa: połowa mieszkań jest tańsza, połowa droższa. Lepiej opisuje typowe mieszkanie, bo nie zawyżają jej pojedyncze, bardzo drogie nieruchomości."
    },
    {
        title: "Średnia",
        description: "Uśredniona wartość wszystkich mieszkań w danym okresie, obliczana jako suma ich cen dzielona przez ich liczbę."
    },
    {
        title: "r/r",
        description: "„rok do roku” – porównanie z tym samym miesiącem poprzedniego roku."
    },
    {
        title: "m/m",
        description: "„miesiąc do miesiąca” – porównanie z poprzednim miesiącem."
    },
    {
        title: "Rynek pierwotny",
        description: "Nowe mieszkania kupowane bezpośrednio od dewelopera."
    },
    {
        title: "RCN",
        description: "Rejestr Cen Nieruchomości – publiczne, bezpłatne źródło danych z wykazem cen transakcyjnych mieszkań."
    }
];
